import $ from 'jquery';
export class PhoneConfirmationModal {
	/*element;
	backLink;
	confirmLink;*/
	constructor(element) {
		this.element = element;
		this.backLink = this.element.find('a.back');
		this.confirmLink = this.element.find('a.confirm');
	}
	
	open() {
		this.backLink.unbind();
		this.confirmLink.unbind();
		
		return new Promise(function (resolve) {
			this.element.css('display', 'block');
			this.backLink.click(function (event) {
				try { gtag('event', 'AcceptPhoneWarning', {'event_category': 'CheckoutSubmit'} ); } catch (e) {}
				resolve(false);
			});
			this.confirmLink.click(function(event) {
				try { gtag('event', 'IgnorePhoneWarning', {'event_category': 'CheckoutSubmit'} ); } catch (e) {}
				resolve(true); 
			});
			this.backLink.click(this.onAnyClick.bind(this));
			this.confirmLink.click(this.onAnyClick.bind(this));
		}.bind(this)) ;
	}
	
	close() {
		this.element.css('display', 'none');
	}
	
	onAnyClick(event) {
		event.preventDefault();
		this.close();
	}
}